<template>
  <el-form-item
    :label="label"
    class="taxation"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="taxation"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left">{{item.label}}</span>
        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{item.value}}</span> -->
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '課税'
    },
    prop: {
      type: String,
      default: 'taxation'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    taxation: {
      get () {
        return this.value
      },
      set (taxation) {
        this.$emit('change', taxation)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const taxation = await this.loadCode()
    const taxationSet = taxation.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = taxationSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'TAXATION' } })
          .then((res) => {
            sessionStorage.setItem('taxation', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('taxation'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.taxation {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
